export class IrsaliyeOlusturRequestKalem {
  teklifKalemId: number;
  adet: number;
  tutar: number;
  paraBirimiId: number;
}
